<template>
  <div :class="$style.field">
    <label :for="id">
      Activity Type
      <i v-if="required">*</i>
    </label>
    <multiselect
      :id="id"
      v-model="value"
      label="name"
      track-by="id"
      placeholder="Please select"
      :allow-empty="!required"
      :show-labels="!required"
      select-label=""
      selected-label="✕"
      deselect-label="✕"
      v-bind="groupingProps"
    >
      <template #noResult>
        <span>No matches found</span>
      </template>
    </multiselect>
    <p v-show="error && showError">{{ error }}</p>
  </div>
</template>

<script>
import axios from "axios";
import omit from "lodash/omit";
import Multiselect from "vue-components/vue-multiselect";
import { createNamespacedHelpers } from "vuex";

const { mapState, mapMutations } = createNamespacedHelpers("activitySummary");

export default {
  components: { Multiselect },
  data() {
    return {
      id: "category_id",
      value: null,
      activityTypes: [],
      showError: false,
    };
  },
  computed: {
    ...mapState(["activity", "formErrors", "selectedTask"]),
    error() {
      return this.formErrors[this.id];
    },
    required() {
      return !this.activity.isInternal;
    },
    groupedActivityTypes() {
      return this.activityTypes.reduce((playbooks, category) => {
        const playbook = playbooks.find(
          (playbook) => playbook.id === category.playbook.id
        );
        if (playbook) {
          playbook.categories.push(category);
        } else {
          const playbook = category.playbook;
          playbook.categories = [omit(category, ["playbook"])];
          playbooks.push(playbook);
        }
        return playbooks;
      }, []);
    },
    groupingProps() {
      return this.groupedActivityTypes.length > 1
        ? {
            "group-values": "categories",
            "group-label": "name",
            options: this.groupedActivityTypes,
          }
        : { options: this.activityTypes };
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(option) {
        this.updateForm(option);
      },
    },
    selectedTask(selectedTask) {
      if (this.value === null) {
        const option = this.activityTypes.find(
          (option) => option.name === selectedTask.type
        );
        if (option) {
          this.value = option;
        }
      }
    },
  },
  created() {
    this.$_activitySummary_config.EventBus.$on(
      "ACTIVITY_FORM_SUBMITTED",
      () => {
        this.showError = true;
      }
    );

    this.$_activitySummary_config.EventBus.$on("UPDATED_INTERNAL_INPUT", () => {
      this.updateForm(this.value);
    });

    this.handleActivityType();
    this.retrieveActivityTypes();
  },
  methods: {
    ...mapMutations(["upsertFormData"]),
    handleActivityType() {
      if (this.activity.category) {
        this.value = this.activity.category;
      }
    },
    updateForm(option) {
      this.showError = false;
      option = option || [];

      const typeId = option.id || null;

      this.upsertFormData({
        id: this.id,
        value: typeId,
        error: this.validate(typeId),
      });
    },
    retrieveActivityTypes() {
      axios
        .get(
          `${this.$_activitySummary_config.jiminnyHost()}/api/v1/organizations/${
            this.$_activitySummary_config.getTeam().id
          }/categories`,
          {
            params: {
              userId: this.$_activitySummary_config.getUser().id,
              type: ["all", this.activity.type],
            },
          }
        )
        .then((response) => {
          this.activityTypes = response.data;
        })
        .catch(console.error);
    },
    validate(value) {
      return this.required && !value ? "Please select the activity type" : null;
    },
  },
};
</script>

<style module lang="less" src="../custom-section/fields/field.less"></style>



// WEBPACK FOOTER //
// select-activity-type.vue?011a909b